<template>
    <app-layout title="Data Penyedia">
        <template #header>
            <BreadCrumb :breadcrumb="$page.props.bc" />
        </template>
        <div class="py-4">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <section class="text-gray-600 body-font">
                        <div class="container px-5 py-5 mx-auto">
                            <div class="flex flex-wrap w-full mb-5 flex-col">
                                <Accordion
                                    :multiple="true"
                                    :activeIndex="[1, 2, 3]"
                                >
                                    <AccordionTab
                                        :disabled="action == 'create'"
                                    >
                                        <template #header>
                                            <span
                                                class="flex align-items-center gap-2 w-full"
                                            >
                                                <span
                                                    class="font-bold white-space-nowrap"
                                                    >Status</span
                                                >
                                            </span>
                                        </template>
                                        <StatusDokumenPengadaanInfo></StatusDokumenPengadaanInfo>
                                    </AccordionTab>
                                    <AccordionTab>
                                        <template #header>
                                            <span
                                                class="flex align-items-center gap-2 w-full"
                                            >
                                                <span
                                                    class="font-bold white-space-nowrap"
                                                    >Data Utama</span
                                                >
                                            </span>
                                        </template>
                                        <div class="p-4 lg:w-1/1 md:w-full">
                                            <div
                                                v-for="attribute in dataViewDokumenPengadaan.dokumen_pengadaan_attribute"
                                                :key="attribute.id"
                                                class="field w-full px-3 mb-3"
                                            >
                                                <JetLabel
                                                    class="w-full my-2"
                                                    :for="attribute.attribute"
                                                    :value="attribute.name"
                                                />
                                                <div :id="attribute.attribute">
                                                    {{
                                                        attribute.type ==
                                                        "currency"
                                                            ? formatRupiah(
                                                                  attribute.existing_attribute
                                                              )
                                                            : attribute.existing_attribute
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                    </AccordionTab>
                                    <AccordionTab>
                                        <template #header>
                                            <span
                                                class="flex align-items-center gap-2 w-full"
                                            >
                                                <span
                                                    class="font-bold white-space-nowrap"
                                                    >Detail Penawaran :
                                                </span>
                                            </span>
                                        </template>
                                        <div
                                            v-for="(
                                                penawaran, index
                                            ) in dataViewDokumenPengadaan.kepersertaan_pengadaan"
                                            :key="index"
                                            class="p-4 lg:w-1/1 md:w-full"
                                        >
                                            <h4>Penyedia {{ index + 1 }}</h4>
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full my-2"
                                                    value="Nilai Evaluasi Administrasi"
                                                />
                                                <InputText
                                                    v-model="
                                                        penawaran.nilai_evaluasi_administrasi
                                                    "
                                                    placeholder="Nilai Evaluasi Administrasi"
                                                />
                                            </div>
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full my-2"
                                                    value="Nilai Evaluasi Kualifikasi"
                                                />
                                                <InputText
                                                    v-model="
                                                        penawaran.nilai_evaluasi_kualifikasi
                                                    "
                                                    placeholder="Nilai Evaluasi Kualifikasi"
                                                />
                                            </div>

                                            <div class="info">
                                                <p>
                                                    <strong
                                                        >Nama
                                                        Perusahaan:</strong
                                                    >
                                                    {{
                                                        penawaran.nama_perusahaan
                                                    }}
                                                </p>
                                                <p>
                                                    <strong
                                                        >NPWP
                                                        Perusahaan:</strong
                                                    >
                                                    {{
                                                        penawaran.npwp_perusahaan
                                                    }}
                                                </p>
                                                <p>
                                                    <strong
                                                        >Alamat
                                                        Perusahaan:</strong
                                                    >
                                                    {{
                                                        penawaran.alamat_perusahaan
                                                    }}
                                                </p>
                                                <p>
                                                    <strong
                                                        >Jenis
                                                        Barang/Jasa:</strong
                                                    >
                                                    {{
                                                        penawaran.jenis_barang_jasa
                                                    }}
                                                </p>
                                                <p>
                                                    <strong
                                                        >Satuan Unit:</strong
                                                    >
                                                    {{ penawaran.satuan_unit }}
                                                </p>
                                                <p>
                                                    <strong
                                                        >Volume Unit:</strong
                                                    >
                                                    {{ penawaran.volume_unit }}
                                                </p>
                                                <p>
                                                    <strong
                                                        >Harga
                                                        Penawaran:</strong
                                                    >
                                                    {{
                                                        penawaran.harga_penawaran
                                                    }}
                                                </p>
                                            </div>

                                            <div
                                                v-if="penawaran.file.length > 0"
                                            >
                                                <h5>File Lampiran:</h5>
                                                <ul>
                                                    <li
                                                        v-for="file in penawaran.file"
                                                        :key="file.name"
                                                        style="margin-top: 10px"
                                                    >
                                                        <Button
                                                            class="p-button-sm"
                                                            :label="
                                                                file
                                                                    .file_kepersertaan_pengadaan_type
                                                                    .nama
                                                            "
                                                            @click="
                                                                $inertia.visit(
                                                                    file.file_path,
                                                                    {
                                                                        method: 'post',
                                                                        data: {
                                                                            _method:
                                                                                'get',
                                                                        },
                                                                        headers:
                                                                            {
                                                                                'Content-Disposition':
                                                                                    'attachment',
                                                                            },
                                                                    }
                                                                )
                                                            "
                                                        />
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </AccordionTab>
                                    <AccordionTab>
                                        <template #header>
                                            <span
                                                class="flex align-items-center gap-2 w-full"
                                            >
                                                <span
                                                    class="font-bold white-space-nowrap"
                                                    >Existing File :
                                                </span>
                                            </span>
                                        </template>
                                        <MultiFileDisplay
                                            :existing_files="
                                                dataViewDokumenPengadaan.dokumen_pengadaan_file
                                            "
                                        />
                                    </AccordionTab>
                                    <AccordionTab>
                                        <template #header>
                                            <span
                                                class="flex align-items-center gap-2 w-full"
                                            >
                                                <span
                                                    class="font-bold white-space-nowrap"
                                                    >Existing Jadwal :
                                                </span>
                                            </span>
                                        </template>
                                        <div class="p-4 lg:w-1/1 md:w-full">
                                            <ul>
                                                <li
                                                    v-for="jadwal in dataViewDokumenPengadaan.dokumen_pengadaan_jadwal"
                                                    :key="
                                                        jadwal.id_jadwal_pengadaan
                                                    "
                                                >
                                                    <strong>{{
                                                        jadwal.nama_jadwal
                                                    }}</strong
                                                    >:
                                                    {{
                                                        jadwal.existing_jadwal
                                                            .waktu_mulai
                                                    }}
                                                    -
                                                    {{
                                                        jadwal.existing_jadwal
                                                            .waktu_selesai
                                                    }}
                                                    ({{
                                                        jadwal.existing_jadwal
                                                            .tempat
                                                    }})
                                                </li>
                                            </ul>
                                        </div>
                                    </AccordionTab>
                                </Accordion>
                            </div>
                            <div class="flex justify-end mt-5">
                                <button
                                    @click="submitForm"
                                    class="px-4 py-2 bg-blue-500 text-white rounded"
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import { defineComponent } from "vue";
import AppLayout from "@/Layouts/AppLayout.vue";
import JetSectionBorder from "@/Jetstream/SectionBorder.vue";
import BreadCrumb from "@/Components/BreadCrumb";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import JetLabel from "@/Jetstream/Label";
import Input from "@/Components/Input";
import StatusDokumenPengadaanInfo from "@/Components/StatusDokumenPengadaanInfo";
import JadwalInput from "./../partials/JadwalInput.vue";
import FileInput from "./../partials/FileInput.vue";
import FileDisplay from "../partials/FileDisplay.vue";
import MultiFileDisplay from "../partials/MultiFileDisplay.vue";
import InputNumber from "primevue/inputnumber";
import Dropdown from "primevue/dropdown";

import axios from "axios";
import { Inertia } from "@inertiajs/inertia";
import InputText from "primevue/inputtext";
import Button from "primevue/button";

export default defineComponent({
    components: {
        AppLayout,
        JetSectionBorder,
        BreadCrumb,
        Accordion,
        AccordionTab,
        JetLabel,
        Input,
        StatusDokumenPengadaanInfo,
        JadwalInput,
        FileInput,
        InputNumber,
        Dropdown,
        FileDisplay,
        MultiFileDisplay,
        InputText,
        Button,
    },
    props: {
        action: String,
        dataViewDokumenPengadaan: Object,
        files: [Object, Array],
    },
    mounted() {
        console.log(
            "DATA dataViewDokumenPengadaan: ",
            this.dataViewDokumenPengadaan
        );
        this.initializeFile();
        this.initializeJadwal();
        this.fetchPenyedia({ query: "" });
    },
    data() {
        return {
            file_uploads: [],
            jadwals: [],
            penyediaOptions: [],
            form: {
                total_hps: null,
                id_penyedia: null,
            },
        };
    },
    methods: {
        initializeFile() {
            this.dataViewDokumenPengadaan.file.forEach((file) => {
                this.file_uploads.push({
                    id_file_dokumen_pengadaan: file.id,
                    id_jadwal_pengadaan: file.id_jadwal_pengadaan,
                    id_dokumen_pengadaan: file.id_dokumen_pengadaan,
                    id_file_dokumen_prosedur: file.id_file_dokumen_prosedur,
                    kode_file: file.kode_file,
                    kode_prosedur: file.kode_prosedur,
                    nama_file: file.nama_file,
                    file_path: file.file_path,
                    file_type: file.file_type,
                    file_dokumen_type: file.file_dokumen_type,
                    file_dokumen_type_id: file.file_dokumen_type_id,
                    multiple: file.is_multiple === 1,
                    new_file: [],
                });
            });
        },
        initializeJadwal() {
            this.dataViewDokumenPengadaan.jadwal.forEach((jadwal) => {
                this.jadwals.push({
                    ...jadwal,
                    ...(this.action == "create"
                        ? {
                              existing_jadwal: {
                                  waktu_mulai: null,
                                  waktu_selesai: null,
                                  tempat: null,
                                  keterangan: null,
                              },
                          }
                        : {}),
                });
            });
        },
        async fetchPenyedia(event) {
            console.log("Keyword : ", event.value);
            try {
                const response = await axios.post(
                    "/dokumen_pengadaan/search_penyedia",
                    {
                        params: {
                            keyword: event?.value || "",
                        },
                    }
                );
                this.penyediaOptions = response.data;
            } catch (error) {
                console.error("Error fetching penyedia:", error);
            }
        },
        submitForm() {
            Inertia.post(
                "/dokumen_pengadaan/action_create_penyusunan_dokumen_pengadaan",
                {
                    form: this.form,
                    file_uploads: this.file_uploads,
                    jadwals: this.jadwals,
                }
            );
        },

        formatRupiah(value) {
            return new Intl.NumberFormat("id-ID", {
                style: "currency",
                currency: "IDR",
            }).format(value);
        },
    },
});
</script>
